import { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { ProviderApi } from 'services';
import { SecurityParamsForm } from './components';
import { useAuthFunctions } from 'contexts/AuthContext';
import { useCompany, useCompanyFunctions } from 'contexts/CompanyContext';
import { useProviderFunctions } from 'contexts/ProviderContext';
import { HeaderParameters } from '../components';
import DefaultModal from 'components/DefaultModal';

const SecurityParameters = () => {
  const { updateUserPassword } = useAuthFunctions();
  const { currentCompany } = useCompany();
  const { editCompanyDocument } = useCompanyFunctions();
  const { editProfilePicture, editProvider } = useProviderFunctions();

  const [open, setOpen] = useState(false);

  async function sendEmailPassword(email) {
    let formData = new FormData();
    formData.append('email', email);

    try {
      await ProviderApi.sendUpdatePasswordEmail(formData);
    } catch (error) { }
  }

  const onDocumentChange = async (document) => {
    let docUpdated = false;
    if (document?.file) {
      let formData = new FormData();
      formData.append('file', document?.file);
      docUpdated = await editCompanyDocument(currentCompany?.id, 'identity', formData, document?.url);
    }

    return docUpdated;
  }

  const onPictureChange = (event) => {
    if (event.target.files !== null && event.target.files.length > 0) {
      const targetFile = event.currentTarget.files[0];
      const file = new Blob([targetFile], { type: 'image/*' });

      let formData = new FormData();
      formData.append('file', targetFile);
      editProfilePicture(file, formData);
    }
  }

  const onSubmitHandler = async (values) => {
    const body = {
      birthday: values.birthday,
      city: values.city,
      country: values.country,
      firstName: values.first_name,
      gender: values.gender,
      lastName: values.last_name,
      phone: values.phone,
    };

    const updated = await editProvider(body);

    if (values.password.length >= 6) {
      const pwdUpdated = await updateUserPassword(values.password);
      if (pwdUpdated) await sendEmailPassword(values.email);
    }

    return updated;
  };

  return (
    <Grid container justifyContent='center' spacing={3} style={{ marginTop: '16px', minHeight: '95vh' }}>
      <HeaderParameters noMargin text='Connexion et Informations'  />

      <SecurityParamsForm
        onDocumentChange={onDocumentChange}
        onPictureChange={onPictureChange}
        onSubmit={onSubmitHandler}
      />

      <DefaultModal
        info
        open={open}
        title='Erreur'
        onClose={() => { setOpen(false)}}
      >
        <Typography>
          Il y a eu un problème lors du changement d'adresse mail ! L'adresse est déjà utilisée.
        </Typography>
      </DefaultModal>
    </Grid>
  );
}

export default SecurityParameters;
